package com.essntl.features.task.ui.addedittask

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.addedittask.components.AddEditTaskHeader
import com.essntl.features.task.ui.addedittask.components.TaskForm
import com.essntl.features.task.ui.addedittask.components.TaskItinerarySection
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AddEditTaskScreen(
    state: AddEditTaskState,
    onEvent: (AddEditTaskEvent) -> Unit,
    validation: AddEditTaskValidation,
    getAllTask: List<TaskModel>? = null,
    onUpdateTaskStatus: (taskId: String, status: TaskModel.Status) -> Unit = { _, _ -> },
    onNavigation: (AddEditTaskNavigation) -> Unit = {},
) {

    val isLoading = remember(state) { state.isLoading }
    val isFailure = remember(state) { state.isFailure }

    val task = rememberFind(
        getAllTask.orEmpty(),
        state.task.value.id,
    ) { task -> task.id }

    val isEdit by remember(state.task.value.id) {
        mutableStateOf(
            state.task.value.id.isNotBlank(),
        )
    }

    LaunchedEffect(isEdit) {
        validation.addEditTaskForm.isEdit = isEdit
    }

    var isEditEnabled by remember(state.getTask.data?.id) { mutableStateOf(false) }
    LaunchedEffect(state.addEditTask.isSuccess) {
        if (state.addEditTask.isSuccess) {
            isEditEnabled = false
        }
    }

    LaunchedEffect(state.getTask.data) {
        validation.addEditTaskForm.reset()
        validation.addEditTaskForm.title.value = state.getTask.data?.title ?: ""
        validation.addEditTaskForm.dueDate.value = state.getTask.data?.dueDate ?: ""
        validation.addEditTaskForm.owner.value = state.getTask.data?.owner?.id ?: state.getCurrentProfile.data?.id ?: ""
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxSize(),
    ) {
        if (getAllTask != null) {
            AddEditTaskHeader(
                task = task,
                onEditTaskStatus = { taskId, status ->
                    onUpdateTaskStatus(taskId, status)
                },
                isLoading = state.addEditTask.isLoading,
                enabled =
                if (isEdit) {
                    isEditEnabled
                } else {
                    true
                },
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(modifier = Modifier.height(1f.spacing))
        }

        Box(
            modifier = Modifier.weight(1f),
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(1f.spacing),
                modifier =
                Modifier
                    .fillMaxSize()
                    .clip(
                        RoundedCornerShape(
                            topStart = 24.dp,
                            topEnd = 24.dp,
                        ),
                    ),
            ) {
                if (isLoading || isFailure ||
                    (isEdit && state.getTask.data == null)
                ) {
                    Box(
                        contentAlignment = Alignment.Center,
                        modifier =
                        Modifier
                            .fillMaxWidth()
                            .height(200.dp)
                            .padding(2.5f.spacing)
                            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                    ) {
                        if (isLoading) {
                            EsSpinner()
                        } else {
                            Text(
                                text = "Something goes wrong!",
                                color = MaterialTheme.esColorScheme.textSecondary,
                                style = MaterialTheme.esTypography.p1Medium16,
                            )
                        }
                    }
                } else {
                    TaskForm(
                        state = state,
                        onEvent = onEvent,
                        validation = validation,
                        getAllTask = getAllTask,
                        enabled = if (isEdit) isEditEnabled else true,
                        modifier = Modifier
                            .weight(1f),
                    )

                    if (
                        getAllTask != null &&
                        state.task.value.id.isNotEmpty()
                    ) {
                        TaskItinerarySection(
                            state = state,
                            task = task,
                            onNavigation = onNavigation,
                        )
                    }
                }
            }
        }

        Spacer(modifier = Modifier.height(1.dp))

        Box(
            modifier = Modifier.background(MaterialTheme.esColorScheme.bgSecondary).padding(2.5.spacing),
        ) {
            EsLargePrimaryButton(
                onClick = {
                    if (isEdit && !isEditEnabled) {
                        isEditEnabled = true
                    } else if (validation.addEditTaskForm.validate()) {
                        if (isEdit) {
                            onEvent(AddEditTaskEvent.EditTask)
                        } else {
                            onEvent(AddEditTaskEvent.AddTask)
                        }
                    }
                },
                text =
                if (isEdit) {
                    if (isEditEnabled) {
                        "Save changes"
                    } else {
                        "Edit"
                    }
                } else {
                    "Add new task"
                },
                loading = state.addEditTask.isLoading,
                enabled = if (isEditEnabled)
                    state.isEditEnabled && validation.addEditTaskForm.isValid else
                    true,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}
